import Button from "components/components/Button/Button";
import styled from "styled-components";
import colours from "styles/colours";

export const SpinnerSection = styled.div`
  height: 500px;
`;

export const StyledCancelButton = styled(Button)`
  && {
    background: transparent;
    color: ${colours.elexonBlue};
    border: 1px solid ${colours.elexonBlue};
    box-shadow: unset;
    padding: 0.6rem 1.9rem;
    height: 2.5rem;
    transition: all 0.3s;

    &&:hover {
      background-color: ${colours.elexonBlue};
      color: ${colours.white};
    }
  }
`;
